import { all } from 'redux-saga/effects';

import disponibilzarDare from './disponibilzarDare/saga';

export default all([disponibilzarDare]);
